import $ from 'jquery';

$(document).on('turbolinks:before-cache', function () {
    $('#js-gallery').nanogallery2('destroy');
});

$(document).on('turbolinks:load', function () {
    $('#js-gallery').nanogallery2({
        galleryMaxRows: 2,
        galleryDisplayMode: 'rows',
        thumbnailHeight: '350',
        thumbnailWidth: '450',
        thumbnailGutterWidth: 2,
        thumbnailGutterHeight: 2,
        thumbnailBorderHorizontal: 0,
        thumbnailBorderVertical: 0,
        thumbnailToolbarImage: null,
        thumbnailToolbarAlbum: null,
        thumbnailLabel: {
            display: true,
            displayDescription: false,
            titleMultiLine: true,
            titleFontSize: '12px',
            position: 'onBottom',
            align: 'left'
        },
        galleryDisplayTransitionDuration: 1500,
        thumbnailDisplayTransition: 'imageSlideUp',
        thumbnailDisplayTransitionDuration: 1200,
        thumbnailDisplayTransitionEasing: 'easeInOutQuint',
        thumbnailDisplayInterval: 60,
        touchAnimation: true,
        touchAutoOpenDelay: 500,

        // LIGHTBOX
        viewerToolbar: {
            display: false
        },
        viewerTools:    {
            topLeft:   'label',
            topRight:  'fullscreenButton, closeButton'
        },

        // GALLERY THEME
        galleryTheme : {
            thumbnail: {
                background: '#111'
            },
        },
    });
});